module.exports = __webpack_public_path__ + "images/stickers/taco-money@2x.5b4b437ec9224433897e.png";